var map = {
	"./categories/babies_page/plan_block.png": [
		92103,
		103
	],
	"./icons/default_icon_service.svg": [
		58757
	],
	"./icons/logo.svg": [
		92688,
		688
	],
	"./icons/mrt-tomograf.svg": [
		84427,
		427
	],
	"./innova-map-pin.svg": [
		27822,
		822
	],
	"./map-pin.svg": [
		64179,
		179
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 79462;
module.exports = webpackAsyncContext;